/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import { APICoreV2 } from '@/utils/servicesApi'

export function getVariableList(params) {
  return requestRaw({
    url: APICoreV2() + '/variable/list',
    method: 'GET',
    params: params
  })
}

export function createVariable(data) {
  return requestRaw({
    url: APICoreV2() + '/variable/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getVariableDetail(data) {
  return requestRaw({
    url: APICoreV2() + '/variable/detail',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function updateVariable(data) {
  return requestRaw({
    url: APICoreV2() + '/variable/update',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function deleteVariable(data) {
  return requestRaw({
    url: APICoreV2() + '/variable/delete',
    method: 'POST',
    data: data // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/variable.js